import React, { useState, useRef, useEffect, useMemo } from "react";

const CustomerRetentionDisount = ({ elem }) => {
    const login = useMemo(() => elem.dataset.loggedin == 'true', [elem]);
    const quantity = useMemo(() => elem.dataset.quantity, [elem]);
    const startDate = useMemo(() => elem.dataset.start, [elem]);
    const endDate = useMemo(() => elem.dataset.end, [elem]);
    
    const [open, setOpen] = useState(!!quantity);
    const [height, setHeight] = useState("400px");

    const ref = useRef(null);

    const toggleHandle = () => {
        setOpen(!open);
    };

    useEffect(() => {
        setTimeout(() => {
            setHeight(ref.current.clientHeight);
        }, 1000);
    }, []);

    return (
        <div
            className={`customerRetentionDiscount ${!!quantity ? 'active' : ''}`}
            style={!open ? { maxHeight: `${height}px` } : {}}
        >
            <div className={`customerRetentionDiscount__title ${open}`} ref={ref} onClick={toggleHandle}>
                <div className="customerRetentionDiscount__title-content">
                    <h3 style={{marginLeft: 0,}}>{quantity ? `${quantity}%` : ''} kedvezmény – Villámakció Hűségjutalom programunk tagjainak</h3>
                
                    {(!!startDate && !!endDate) ? 
                        <div className="customerRetentionDiscount__date">
                            <p>{startDate.toLowerCase()} - {endDate.toLowerCase()}</p>
                        </div>
                    : ''}
                </div>
                <button className="customerRetentionDiscount__toggle">
                    <img src="/images/icon/chevron.svg" alt="Chevron" className="chevron" />
                </button>
            </div>

            <div className={`customerRetentionDiscount__input ${open ? "show" : ""}`}>
                <p>A DiBook HŰSÉGJUTALOM programnak 4 szintje van: Bronz, Ezüst, Arany és Platina. Minden szinthez el kell érni egy adott vásárlási értéket – erre  egy teljes évszak áll rendelkezésedre.</p>

                <p className="mb-0">Ha jelenleg <b>BRONZ</b> szinten vagy, akkor <b>1 szabadon megjelölt kategóriában</b>...</p>
                <p className="mb-0">Ha jelenleg <b>EZÜST</b> szinten vagy, akkor <b>3 szabadon megjelölt kategóriában</b>...</p>
                <p className="mb-0">Ha jelenleg <b>ARANY</b> szinten vagy, akkor <b>5 szabadon megjelölt kategóriában</b>...</p>
                <p className="mb-0">Ha jelenleg <b>PLATINA</b> szinten vagy, akkor <b>7 szabadon megjelölt kategóriában</b>...</p>

                <p className="mt-2">…kapsz bármennyi digitális könyvre 10%, 15%, 20% vagy akár még nagyobb mértékű kedvezményt a 
                meghirdetéstől függően. Árkötött termékek esetében maximum 10% kedvezmény adható.</p>
            
                <div className="customerRetentionDiscount__input__buttonWrapper">
                    <a href="/akciok/husegjutalom/tajekoztato">
                        <button className="customerRetentionDiscount__input__button">Tovább a HŰSÉGJUTALOM program részleteihez</button>
                    </a>

                    {login ?
                    <>
                        {!!quantity ?
                        <a href="/akciok/husegjutalom">
                            <button className="customerRetentionDiscount__input__button">
                                    Tovább a villámakcióhoz
                            </button>
                        </a> : 
                        <button 
                            className="customerRetentionDiscount__input__button" 
                            disabled>
                                Jelenleg nincs villámakció
                        </button>}
                    </> : null}
                </div>

                {!login ?
                <>
                    <p className="mt-5">Amennyiben a Hűségjutalom program regisztrált tagja vagy, de ezzel a szöveggel találkozol, akkor jelentkezz be a fiókodba, majd az Akciók oldalról részt tudsz venni a villámakcióban.</p>

                    <div className="customerRetentionDiscount__input__buttonWrapper">
                        <button className="customerRetentionDiscount__input__button" onClick={() => $("#loginModal").modal()}>Bejelentkezem</button>
                    </div>
                </>
                : null }
            </div>
        </div>
    );
};

export default CustomerRetentionDisount;
